export var maskPhoneNumber = function (telNumber) {
    if (!telNumber)
        return '***';
    var clean = telNumber.trim();
    if (clean.length <= 3) {
        return '***';
    }
    var firstNumber = clean[0];
    var lastNumbers = clean.slice(-3);
    var middle = clean.slice(1, -3);
    var maskedMiddle = middle.replace(/\d/g, '*');
    var visibleMiddle = maskedMiddle.slice(0, 2);
    return "".concat(firstNumber).concat(visibleMiddle, " *** ").concat(lastNumbers);
};
